{
  "ticket": {
    "title": "Ticket hỗ trợ",
    "subtitle": "Hàng đợi hỗ trợ khách hàng",
    "columns": {
      "id": "Mã ticket",
      "subject": "Tiêu đề",
      "merchant": "Merchant",
      "assignee": "Người xử lý",
      "priority": "Ưu tiên",
      "status": "Trạng thái",
      "category": "Phân loại",
      "createdAt": "Ngày tạo",
      "updatedAt": "Cập nhật",
      "sla": "SLA"
    },
    "actions": {
      "create": "Ticket mới",
      "assign": "Phân công",
      "reassign": "Phân công lại",
      "close": "Đóng",
      "reopen": "Mở lại",
      "reply": "Trả lời",
      "addNote": "Thêm ghi chú nội bộ",
      "escalate": "Leo thang"
    },
    "filters": {
      "status": "Trạng thái",
      "priority": "Ưu tiên",
      "category": "Phân loại",
      "assignee": "Người xử lý",
      "overdue": "Chỉ quá hạn",
      "search": "Tìm ticket"
    },
    "empty": {
      "title": "Không có ticket",
      "body": "Không có ticket nào khớp với bộ lọc."
    },
    "errors": {
      "loadFailed": "Không tải được ticket",
      "assignFailed": "Phân công ticket thất bại"
    },
    "detail": {
      "conversation": "Hội thoại",
      "history": "Lịch sử",
      "attachments": "Tệp đính kèm",
      "relatedOrders": "Đơn hàng liên quan",
      "merchantInfo": "Thông tin merchant"
    }
  },
  "ticket_status": {
    "open": "Mở",
    "inProgress": "Đang xử lý",
    "waitingCustomer": "Chờ khách hàng",
    "waitingVendor": "Chờ vendor",
    "resolved": "Đã giải quyết",
    "closed": "Đã đóng"
  },
  "ticket_priority": {
    "low": "Thấp",
    "normal": "Bình thường",
    "high": "Cao",
    "urgent": "Khẩn cấp"
  },
  "ticket_category": {
    "order": "Vấn đề đơn hàng",
    "shipping": "Vận chuyển",
    "payment": "Thanh toán",
    "product": "Chất lượng sản phẩm",
    "account": "Tài khoản",
    "technical": "Kỹ thuật",
    "other": "Khác"
  },
  "sla": {
    "label": "SLA",
    "withinSla": "Trong SLA",
    "approachingSla": "Sắp vi phạm SLA",
    "breached": "Vi phạm SLA",
    "timeRemaining": "Còn lại: {{time}}",
    "timeOverdue": "Quá hạn: {{time}}"
  },
  "dashboard": {
    "title": "Dashboard hỗ trợ",
    "subtitle": "KPI và hiệu suất nhân viên",
    "kpis": {
      "openTickets": "Ticket đang mở",
      "avgResponseTime": "Thời gian phản hồi TB",
      "avgResolutionTime": "Thời gian xử lý TB",
      "slaCompliance": "Tuân thủ SLA",
      "slaBreaches": "Vi phạm SLA (24h)",
      "satisfaction": "Điểm hài lòng (CSAT)"
    },
    "charts": {
      "ticketsOverTime": "Ticket theo thời gian",
      "categoryBreakdown": "Phân loại",
      "priorityBreakdown": "Theo ưu tiên",
      "agentLoad": "Tải nhân viên"
    },
    "agentTable": {
      "title": "Hiệu suất nhân viên",
      "columns": {
        "agent": "Nhân viên",
        "active": "Đang xử lý",
        "resolved24h": "Đã giải quyết (24h)",
        "avgResponse": "Phản hồi TB",
        "csat": "CSAT"
      }
    },
    "filters": {
      "dateRange": "Khoảng ngày",
      "team": "Nhóm"
    }
  },
  "statusLabels": {
    "Open": "Đang mở",
    "InProgress": "Đang xử lý",
    "In Progress": "Đang xử lý",
    "AwaitingHandler": "Chờ bên xử lý",
    "PendingSupportReview": "Chờ Support tổng hợp",
    "Resolved": "Đã xử lý",
    "Closed": "Đã đóng",
    "Reopened": "Mở lại"
  },
  "originLabels": {
    "merchant": "Do merchant mở",
    "vendor": "Do vendor mở",
    "admin": "Do admin mở"
  },
  "deptQueue": {
    "title": "Queue dispatch theo bộ phận",
    "loading": "Đang tải…",
    "empty": "Bộ phận này chưa có dispatch nào.",
    "colTicket": "Ticket cha",
    "colStatus": "Trạng thái",
    "colScopeNote": "Tóm tắt việc",
    "colCreatedAt": "Tạo lúc",
    "openTicket": "Mở ticket"
  },
  "priorityLabels": {
    "Critical": "Nghiêm trọng",
    "High": "Cao",
    "Medium": "Trung bình",
    "Low": "Thấp"
  },
  "categoryLabels": {
    "Order": "Đơn hàng",
    "Billing": "Thanh toán",
    "Product": "Sản phẩm",
    "Account": "Tài khoản",
    "General": "Chung"
  },
  "bugStatusLabels": {
    "open": "Mở",
    "in_progress": "Đang xử lý",
    "resolved": "Đã giải quyết",
    "closed": "Đã đóng"
  },
  "bugPriorityLabels": {
    "low": "Thấp",
    "medium": "Trung bình",
    "high": "Cao",
    "critical": "Nghiêm trọng"
  },
  "ticketsPage": {
    "heading": "Ticket hỗ trợ",
    "subtitle": "Hàng đợi ticket theo SLA, ưu tiên và hạng mục.",
    "totalCount": "{{total}} ticket",
    "forbidden": "Bạn không có quyền xem ticket hỗ trợ.",
    "loadError": "Không tải được danh sách ticket.",
    "tablistAria": "Trạng thái ticket",
    "tableAria": "Danh sách ticket hỗ trợ",
    "tabs": {
      "all": "Tất cả",
      "open": "Đang mở",
      "inProgress": "Đang xử lý",
      "resolved": "Đã xử lý",
      "closed": "Đã đóng",
      "reopened": "Mở lại"
    },
    "columns": {
      "id": "ID",
      "subject": "Tiêu đề",
      "merchant": "Merchant",
      "priority": "Ưu tiên",
      "status": "Trạng thái",
      "sla": "SLA",
      "assignee": "Người xử lý",
      "createdAt": "Tạo lúc"
    },
    "loading": "Đang tải…",
    "empty": "Không có ticket nào khớp bộ lọc hiện tại.",
    "rows": "Số dòng",
    "rowsPerPageAria": "Số dòng mỗi trang",
    "merchantFallback": "Merchant {{id}}",
    "unassigned": "Chưa gán"
  },
  "ticketDetail": {
    "missingId": "Thiếu mã ticket trên URL.",
    "backToList": "Quay về danh sách",
    "back": "Tickets",
    "loadError": "Không thể tải chi tiết ticket: {{message}}",
    "unknownError": "Lỗi không xác định.",
    "updateSuccess": "Đã cập nhật ticket",
    "updateFailTitle": "Không cập nhật được",
    "escalatedBadge": "Đã escalate · Cấp {{level}}",
    "escalateBtn": "Escalate",
    "createdAt": "Tạo {{time}}",
    "requesterLabel": "Người gửi:",
    "firstResponseLabel": "Phản hồi đầu:",
    "resolutionLabel": "Giải quyết:",
    "categoryLabel": "Hạng mục:",
    "description": "Mô tả",
    "attachments": "Tệp đính kèm",
    "transitions": {
      "start": "Bắt đầu xử lý",
      "markResolved": "Đánh dấu đã giải quyết",
      "close": "Đóng ticket",
      "reopen": "Mở lại"
    }
  },
  "slaWarning": {
    "aria": "Cảnh báo SLA",
    "firstResponseTitle": "SLA: Quá hạn phản hồi",
    "resolutionTitle": "SLA: Quá hạn giải quyết",
    "respondBy": "Cần phản hồi trước: {{time}}",
    "resolveBy": "Cần giải quyết trước: {{time}}",
    "firstResponseAction": "Đã quá hạn phản hồi — Cần xử lý ngay",
    "resolutionAction": "Đã quá hạn giải quyết — Cần xử lý ngay"
  },
  "supportDashboard": {
    "forbiddenTitle": "Không có quyền truy cập",
    "forbiddenBody": "Tài khoản hiện tại không có quyền xem báo cáo Support.",
    "heading": "Báo cáo hỗ trợ",
    "kpiAria": "Chỉ số hỗ trợ",
    "chartsAria": "Biểu đồ hỗ trợ",
    "kpi": {
      "open": "Ticket đang mở",
      "overdue": "Quá hạn",
      "avgResponse": "Phản hồi đầu TB",
      "resolvedToday": "Đã xử lý hôm nay"
    },
    "slaChartTitle": "Tuân thủ SLA theo mức độ",
    "volumeChartTitle": "Khối lượng theo hạng mục",
    "agentSectionTitle": "Hiệu suất nhân viên",
    "empty": "Chưa có ticket nào.",
    "error": "Không tải được dữ liệu Support — đang thử lại."
  },
  "conversation": {
    "sectionAria": "Cuộc hội thoại của ticket",
    "tablistAria": "Loại tin nhắn",
    "tabs": {
      "public": "Merchant",
      "internal": "Ghi chú nội bộ"
    },
    "internalBadge": "Nội bộ",
    "internalBanner": "Ghi chú nội bộ không tính vào SLA và không gửi cho khách hàng.",
    "emptyPublic": "Chưa có tin nhắn công khai nào.",
    "emptyInternal": "Chưa có ghi chú nội bộ nào.",
    "dispatchButton": "Đẩy xử lý"
  },
  "replyBox": {
    "sectionAria": "Hộp soạn trả lời",
    "heading": "Trả lời",
    "typeLabel": "Loại",
    "type": {
      "public": "Công khai (gửi cho khách hàng)",
      "internal": "Nội bộ (chỉ admin)"
    },
    "placeholderPublic": "Soạn trả lời gửi cho khách hàng.",
    "placeholderInternal": "Ghi chú nội bộ — khách hàng không thấy.",
    "removeAttachment": "Bỏ {{filename}}",
    "uploading": "Đang tải...",
    "attach": "Đính kèm tệp",
    "sending": "Đang gửi...",
    "send": "Gửi",
    "uploadFailTitle": "Không thể tải tệp đính kèm",
    "emptyContentTitle": "Chưa có nội dung",
    "emptyContentBody": "Vui lòng nhập nội dung trước khi gửi.",
    "sentNoteTitle": "Đã thêm ghi chú nội bộ",
    "sentReplyTitle": "Đã gửi trả lời",
    "sendFailTitle": "Không gửi được",
    "unknownError": "Lỗi không xác định.",
    "internalToggle": "Ghi chú nội bộ (chỉ support thấy)"
  },
  "infoSidebar": {
    "aside": "Thông tin ticket",
    "statusSection": "Trạng thái",
    "statusLabel": "Trạng thái",
    "priorityLabel": "Ưu tiên",
    "assigneeLabel": "Người xử lý",
    "escalated": "Đã escalate cấp {{level}}",
    "relatedOrders": "Đơn hàng liên quan",
    "noRelatedOrders": "Chưa liên kết đơn hàng nào.",
    "activity": "Hoạt động",
    "noActivity": "Chưa có hoạt động nào được ghi nhận.",
    "system": "Hệ thống"
  },
  "assigneePicker": {
    "unassigned": "— Chưa giao —",
    "searchPlaceholder": "Tìm theo tên hoặc email…",
    "noMatch": "Không tìm thấy admin khớp \"{{query}}\"."
  },
  "slaBadge": {
    "overdue": "Quá hạn",
    "now": "ngay bây giờ",
    "closed": "Đã đóng",
    "closedAria": "Ticket đã đóng",
    "unknown": "SLA không xác định",
    "leftDaysHours": "Còn {{days}}n {{hours}}g",
    "leftDays": "Còn {{days}}n",
    "leftHoursMins": "Còn {{hours}}g {{mins}}p",
    "leftHours": "Còn {{hours}}g",
    "leftMins": "Còn {{mins}}p",
    "ariaOverdue": "SLA đã quá hạn {{mins}} phút",
    "ariaRemaining": "SLA còn {{copy}}"
  },
  "listFilters": {
    "regionAria": "Bộ lọc danh sách ticket hỗ trợ",
    "priorityLabel": "Mức độ",
    "priorityAria": "Lọc theo mức độ ưu tiên",
    "categoryLabel": "Hạng mục",
    "categoryAria": "Lọc theo hạng mục",
    "assigneeLabel": "Người xử lý",
    "assigneeAria": "Lọc theo người xử lý",
    "all": "Tất cả",
    "assigneeAll": "Người xử lý (tất cả)",
    "unassigned": "Chưa gán",
    "overdue": "Quá hạn",
    "searchPlaceholder": "Tìm theo ID hoặc tiêu đề…",
    "searchAria": "Tìm ticket theo mã hoặc tiêu đề"
  },
  "escalate": {
    "title": "Escalate ticket",
    "modeLegend": "Cách chọn admin",
    "modeRoundRobin": "Round-robin (tự động gán admin trực)",
    "modePick": "Chọn admin cụ thể",
    "pickLabel": "Admin nhận",
    "pickPlaceholder": "— Chọn admin —",
    "slaLabel": "SLA mới (giờ)",
    "slaHint": "Mặc định {{hours}} giờ.",
    "noteLabel": "Ghi chú",
    "notePlaceholder": "Lý do escalate (ghi vào nhật ký kiểm toán).",
    "cancel": "Huỷ",
    "confirm": "Xác nhận escalate",
    "sending": "Đang gửi...",
    "noAdminTitle": "Chưa chọn admin",
    "noAdminBody": "Vui lòng chọn admin để escalate.",
    "noNoteTitle": "Thiếu lý do",
    "noNoteBody": "Vui lòng nhập ghi chú cho việc escalate.",
    "invalidSlaTitle": "SLA không hợp lệ",
    "invalidSlaBody": "SLA phải là số giờ dương.",
    "successTitle": "Đã escalate ticket",
    "failTitle": "Không thể escalate",
    "unknownError": "Lỗi không xác định."
  },
  "agentTable": {
    "empty": "Chưa có agent nào xử lý ticket.",
    "columns": {
      "agent": "Nhân viên",
      "open": "Đang mở",
      "avgResponse": "Phản hồi đầu TB",
      "resolutionRate": "Tỷ lệ giải quyết"
    }
  },
  "charts": {
    "sla": {
      "empty": "Chưa có ticket nào để chấm SLA.",
      "aria": "Tuân thủ SLA theo mức độ",
      "met": "Đạt",
      "missed": "Trễ"
    },
    "volume": {
      "empty": "Chưa có ticket nào để phân loại.",
      "aria": "Khối lượng ticket theo hạng mục"
    }
  },
  "bugTracker": {
    "title": "Bug Tracker",
    "forbiddenBody": "Bạn không có quyền truy cập Bug Tracker. Trang này chỉ dành cho Super Admin.",
    "saLock": "Chỉ Super Admin",
    "subtitle": "Quản lý bug reports — kéo-thả thẻ sang cột khác để chuyển trạng thái. Tất cả lỗi runtime từ admin SPA tự động được đẩy vào đây (auto-reported).",
    "autoBannerText": "lỗi auto-reported trong 7 ngày qua. Bật bộ lọc \"Chỉ auto-reported\" để xem riêng.",
    "viewToggleAria": "Chuyển dạng xem",
    "viewKanban": "Kanban",
    "viewTable": "Bảng",
    "severity": "Mức độ",
    "all": "Tất cả",
    "autoOnly": "Chỉ auto-reported",
    "search": "Tìm kiếm",
    "searchPlaceholder": "tiêu đề hoặc mô tả...",
    "refresh": "Làm mới",
    "loading": "Đang tải bug reports…",
    "loadError": "Không thể tải bug reports.",
    "table": {
      "empty": "Chưa có bug report nào khớp bộ lọc.",
      "title": "Tiêu đề",
      "status": "Trạng thái",
      "priority": "Mức độ",
      "category": "Hạng mục",
      "reporter": "Người báo",
      "assignee": "Người xử lý",
      "created": "Ngày tạo",
      "occurrences": "Số lần"
    },
    "modal": {
      "close": "Đóng",
      "id": "ID:",
      "created": "Tạo:",
      "seen": "Xuất hiện: {{count}} lần",
      "auto": "auto",
      "statusLabel": "Trạng thái",
      "assigneeLabel": "Người xử lý (user_id)",
      "assigneePlaceholder": "ObjectId hoặc bỏ trống",
      "save": "Lưu",
      "linked": "Liên kết",
      "merchant": "Merchant:",
      "vendor": "Vendor:",
      "order": "Đơn hàng:",
      "sourceUrl": "Source URL:",
      "description": "Mô tả",
      "noDescription": "(không có mô tả)",
      "stackTrace": "Stack trace",
      "screenshots": "Ảnh chụp màn hình ({{count}})",
      "comments": "Bình luận ({{count}})",
      "noComments": "Chưa có bình luận."
    },
    "create": {
      "button": "Tạo bug",
      "heading": "Tạo báo cáo bug",
      "titleLabel": "Tiêu đề",
      "titlePlaceholder": "Mô tả ngắn về vấn đề",
      "descriptionLabel": "Mô tả",
      "descriptionPlaceholder": "Chuyện gì xảy ra, ở đâu, và cách tái hiện",
      "categoryLabel": "Phân loại",
      "priorityLabel": "Mức ưu tiên",
      "assigneeLabel": "Người phụ trách",
      "assigneePlaceholder": "ObjectId hoặc để trống",
      "submit": "Tạo",
      "submitting": "Đang tạo…",
      "cancel": "Huỷ",
      "titleRequired": "Phải có tiêu đề (tối thiểu 2 ký tự).",
      "createError": "Không tạo được báo cáo bug.",
      "manualHint": "Báo cáo tạo tay không được đánh dấu là tự động ghi nhận.",
      "assigneeUnassigned": "Chưa gán",
      "assigneeSearchPlaceholder": "Tìm admin theo tên hoặc email…",
      "assigneeSearching": "Đang tìm…",
      "assigneeNoResults": "Không tìm thấy admin"
    }
  },
  "kanban": {
    "regionAria": "Bảng Kanban Bug Tracker",
    "columnAria": "Cột {{label}}",
    "empty": "Không có bug ở trạng thái này",
    "cardAria": "Bug: {{title}} ({{priority}})",
    "unassigned": "chưa gán",
    "reporterTitle": "Người báo: {{name}}",
    "assigneeTitle": "Người xử lý: {{name}}",
    "screenshotsAria": "{{count}} ảnh chụp màn hình"
  },
  "listV2": {
    "refresh": "Làm mới",
    "newTicket": "Tạo ticket",
    "searchPlaceholder": "Tìm theo mã ticket, tiêu đề, hoặc email...",
    "allStatuses": "Tất cả trạng thái",
    "allCategories": "Tất cả danh mục",
    "allChannels": "Tất cả kênh",
    "allPriorities": "Tất cả ưu tiên",
    "allTypes": "Tất cả loại",
    "allAssignees": "Tất cả người xử lý",
    "typeInternal": "Nội bộ",
    "typeMerchant": "Merchant",
    "showingCount": "Hiển thị {{shown}} / {{total}} ticket",
    "showingRecords": "Hiển thị {{from}}-{{to}} / {{total}} dòng",
    "selectAll": "Chọn tất cả",
    "selectRow": "Chọn dòng",
    "viewDetail": "Xem chi tiết",
    "moreActions": "Thao tác khác",
    "stats": {
      "open": "Đang mở",
      "urgent": "Khẩn cấp",
      "overdueSla": "Quá hạn SLA",
      "resolvedToday": "Đã xử lý hôm nay"
    },
    "columns": {
      "ticket": "Mã ticket",
      "type": "Loại",
      "category": "Danh mục",
      "assigned": "Người xử lý",
      "lastUpdated": "Cập nhật cuối",
      "actions": "Thao tác"
    },
    "quickFilters": {
      "heading": "Lọc nhanh"
    },
    "assignSuccess": "Đã gán ticket",
    "unassign": "Bỏ gán",
    "bulk": {
      "selectedCount": "Đã chọn {{count}}",
      "assign": "Gán cho…",
      "setStatus": "Đổi trạng thái…",
      "setPriority": "Đổi ưu tiên…",
      "markRead": "Đánh dấu đã đọc",
      "clear": "Bỏ chọn",
      "done": "{{ok}} đã cập nhật",
      "failed": "{{fail}} thất bại",
      "skipped": "{{skipped}} bị bỏ qua (chuyển trạng thái không hợp lệ)"
    }
  },
  "newTicket": {
    "title": "Tạo ticket mới",
    "subject": "Tiêu đề",
    "description": "Mô tả",
    "merchant": "Merchant",
    "merchantPlaceholder": "Tìm merchant theo tên hoặc email...",
    "merchantLoading": "Đang tìm...",
    "merchantEmpty": "Không tìm thấy merchant.",
    "category": "Danh mục",
    "priority": "Ưu tiên",
    "type": "Loại ticket",
    "cancel": "Huỷ",
    "create": "Tạo",
    "creating": "Đang tạo...",
    "created": "Đã tạo ticket.",
    "createFailed": "Không tạo được ticket."
  },
  "detailV2": {
    "backToTickets": "Quay lại danh sách",
    "notFound": "Không tìm thấy ticket.",
    "issueDescription": "Mô tả vấn đề",
    "conversation": "Hội thoại ({{count}} tin nhắn)",
    "noMessages": "Chưa có tin nhắn.",
    "internalNote": "Ghi chú nội bộ",
    "internalNoteHint": "Ghi chú nội bộ (chỉ nhân viên thấy)",
    "replyPlaceholder": "Nhập tin nhắn...",
    "sendReply": "Gửi trả lời",
    "sendFailed": "Không gửi được tin nhắn.",
    "ticketStatus": "Trạng thái ticket",
    "assign": "Phân công",
    "escalate": "Leo thang",
    "escalatedBadge": "Đã leo thang · Cấp {{level}}",
    "merchantInformation": "Thông tin Merchant",
    "merchantOrders": "{{count}} đơn hàng",
    "merchantLifetime": "{{amount}} tổng chi tiêu",
    "resolution": "Hướng xử lý",
    "resolutionType": "Loại xử lý",
    "resolutionNotes": "Ghi chú xử lý",
    "resolve": "Đóng ticket (Resolve)",
    "ratingTitle": "Đánh giá của merchant",
    "activityLog": "Nhật ký hoạt động",
    "noActivity": "Chưa có hoạt động.",
    "createdAt": "Tạo lúc",
    "updatedAt": "Cập nhật",
    "resolvedAt": "Xử lý xong",
    "updated": "Đã cập nhật ticket.",
    "updateFailed": "Không cập nhật được ticket.",
    "vendorThread": "Thread vendor — {{vendor}}",
    "vendorThreadHint": "Merchant không nhìn thấy",
    "vendorFallback": "Vendor",
    "vendorReplyPlaceholder": "Nhắn cho vendor...",
    "vendorStatusLabels": {
      "Pending": "Vendor: Chờ nhận",
      "InProgress": "Vendor: Đang xử lý",
      "Done": "Vendor: Hoàn tất"
    },
    "relatedOrders": "Đơn hàng liên quan",
    "noRelatedOrders": "Không có đơn hàng liên quan",
    "linkOrderSearch": "Tìm đơn hàng theo số…",
    "linkOrderLink": "Gắn",
    "linkOrderUnlink": "Bỏ gắn",
    "linkOrderLinked": "Đơn đã gắn",
    "linkOrderEmpty": "Không tìm thấy đơn hàng",
    "resolveNeedsOrder": "Hãy gắn đơn hàng liên quan trước khi resolve với hành động này.",
    "activity": {
      "escalated": "Đã escalate",
      "dispatched": "Đã dispatch cho vendor",
      "pushedToVendor": "Đã đẩy sang vendor",
      "dispatchCancelled": "Đã huỷ dispatch",
      "dispatchReturned": "Dispatch bị trả lại",
      "relatedOrdersSet": "Đã gắn đơn hàng",
      "merchantConfirmedClose": "Merchant xác nhận đóng",
      "vendorClosed": "Vendor đã đóng",
      "merchantReopened": "Merchant mở lại",
      "unassignedFallback": "Tự bỏ phân công",
      "updated": "Đã cập nhật"
    },
    "permissionDenied": "Bạn không có quyền thực hiện thao tác này.",
    "readByMerchant": "Merchant đã đọc",
    "sentAwaitingRead": "Đã gửi — chưa đọc",
    "pushToVendor": "Đẩy cho Vendor",
    "pushToDepartment": "Đẩy cho Bộ phận",
    "activityFields": {
      "assignee": "Người phụ trách",
      "status": "Trạng thái",
      "priority": "Độ ưu tiên",
      "category": "Danh mục"
    }
  },
  "pushVendor": {
    "cta": "Chuyển cho Vendor",
    "repush": "Đã chuyển vendor",
    "title": "Chuyển ticket cho vendor",
    "description": "Vendor nhận thông tin ticket + thread trao đổi riêng. Vendor KHÔNG thấy hội thoại với merchant.",
    "vendor": "Vendor",
    "vendorPlaceholder": "Chọn vendor...",
    "note": "Ghi chú bàn giao",
    "notePlaceholder": "Bối cảnh cho vendor (hiện trong thread vendor)...",
    "confirm": "Chuyển",
    "pushing": "Đang chuyển...",
    "pushed": "Đã chuyển ticket cho vendor.",
    "failed": "Không chuyển được ticket."
  },
  "resolutionLabels": {
    "Reprint": "In lại (Reprint)",
    "FullRefund": "Hoàn tiền toàn bộ",
    "PartialRefund": "Hoàn tiền một phần",
    "StoreCredit": "Store Credit",
    "Replacement": "Đổi hàng",
    "ShippingCredit": "Hoàn phí ship",
    "NoActionRequired": "Không cần xử lý",
    "Escalated": "Đã escalate"
  },
  "inboxV2": {
    "title": "Hộp thư",
    "chipAll": "Tất cả",
    "chipOpen": "Đang mở",
    "chipAssignedToMe": "Gán cho tôi",
    "searchPlaceholder": "Tìm hội thoại...",
    "empty": "Chưa có hội thoại.",
    "selectPrompt": "Chọn một hội thoại để bắt đầu trò chuyện",
    "openTicket": "Mở ticket →",
    "unreadDot": "Chưa đọc"
  },
  "performanceV2": {
    "heading": "Hiệu suất Support",
    "subtitle": "Phân tích hiệu suất agent và mức hài lòng của merchant",
    "startDate": "Từ ngày",
    "endDate": "Đến ngày",
    "category": "Danh mục",
    "agent": "Agent",
    "rating": "Đánh giá",
    "allAgents": "Tất cả agent",
    "allRatings": "Tất cả mức sao",
    "reset": "Đặt lại",
    "totalRated": "Tổng đánh giá",
    "averageRating": "Điểm trung bình",
    "satisfactionRate": "Tỉ lệ hài lòng",
    "satisfactionSub": "4-5 sao",
    "avgResponseTime": "Phản hồi trung bình",
    "leaderboard": "Bảng xếp hạng agent",
    "rank": "Hạng",
    "agentCol": "Agent",
    "ticketsHandled": "Ticket đã xử lý",
    "ratingCol": "Đánh giá",
    "responseTime": "Thời gian phản hồi",
    "slaBreach": "Vi phạm SLA",
    "noData": "Chưa có dữ liệu hiệu suất",
    "ratingDistribution": "Phân bố đánh giá",
    "categoryBreakdown": "Theo danh mục",
    "categoryCol": "Danh mục"
  },
  "configV2": {
    "heading": "Cấu hình Support",
    "subtitle": "Quản lý kênh và thiết lập agent",
    "tabChannels": "Kênh",
    "tabAgents": "Agent",
    "totalConnections": "Tổng kết nối",
    "searchChannels": "Tìm kênh...",
    "addChannel": "Thêm kênh",
    "saveChannel": "Lưu",
    "colName": "Tên",
    "colType": "Loại",
    "colUpdated": "Cập nhật cuối",
    "colActive": "Hoạt động",
    "noChannels": "Chưa có kênh nào. Thêm kênh đầu tiên để bắt đầu.",
    "channelCreated": "Đã thêm kênh.",
    "channelDeleted": "Đã xoá kênh.",
    "deleteChannel": "Xoá kênh",
    "actionFailed": "Thao tác thất bại.",
    "channelTypes": {
      "webchat": "Webchat",
      "email": "Email",
      "ai_bot": "AI Bot",
      "staff": "Nhân viên"
    },
    "colAgent": "Agent",
    "colEmail": "Email",
    "colRole": "Vai trò",
    "noAgents": "Chưa có agent support nào.",
    "colStatus": "Trạng thái",
    "colCategories": "Danh mục",
    "colLoad": "Tải",
    "colWorkingHours": "Giờ làm việc",
    "addAgent": "Thêm agent",
    "configure": "Cấu hình",
    "removeAgent": "Xoá agent",
    "searchAgents": "Tìm agent theo tên…",
    "availableAll": "Tất cả trạng thái sẵn sàng",
    "categoryAll": "Tất cả danh mục",
    "totalAgents": "Tổng số agent",
    "agentLoadError": "Không thể tải danh sách agent.",
    "unassignedQueue": "Hàng chờ chưa gán",
    "unassignedTickets": "{{count}} ticket chưa gán đang chờ phân công",
    "agentStatus": {
      "available": "Sẵn sàng",
      "unavailable": "Không sẵn sàng",
      "atCap": "Đã đầy tải",
      "outOfHours": "Ngoài giờ làm"
    },
    "pairBridge": "Ghép bridge Facebook (Cá nhân)",
    "pairBridgeSubtitle": "Tạo kênh bridge và cấp token thiết bị dùng một lần cho runner headless.",
    "deviceToken": "Token thiết bị",
    "deviceTokenHint": "Sao chép token ngay — chỉ hiển thị một lần.",
    "copyToken": "Sao chép token",
    "tokenCopied": "Đã sao chép token",
    "revokeDevice": "Thu hồi",
    "revokeConfirm": "Thu hồi thiết bị này? Token sẽ ngừng hoạt động ngay lập tức.",
    "devicesTitle": "Thiết bị đã ghép",
    "colDeviceStatus": "Trạng thái thiết bị",
    "pairSuccess": "Đã ghép bridge. Sao chép token ngay.",
    "pairFailed": "Ghép thất bại.",
    "agentUserIdLabel": "ID người dùng agent",
    "channelNameLabel": "Tên kênh",
    "colMaxConcurrent": "Tối đa"
  },
  "agentConfig": {
    "title": "Cấu hình agent — {{name}}",
    "available": "Sẵn sàng",
    "availableHint": "Agent nhận phân công ticket mới",
    "workingHours": "Giờ làm việc",
    "timezone": "Múi giờ",
    "timezonePlaceholder": "vd: Asia/Ho_Chi_Minh",
    "windowsEmpty": "Chưa có khung giờ — sẵn sàng mọi lúc.",
    "addWindow": "Thêm khung giờ",
    "removeWindow": "Xoá khung giờ",
    "day": "Ngày",
    "startTime": "Bắt đầu",
    "endTime": "Kết thúc",
    "days": {
      "sun": "Chủ nhật",
      "mon": "Thứ hai",
      "tue": "Thứ ba",
      "wed": "Thứ tư",
      "thu": "Thứ năm",
      "fri": "Thứ sáu",
      "sat": "Thứ bảy"
    },
    "categories": "Danh mục",
    "categoriesHint": "Bỏ trống để xử lý mọi danh mục.",
    "maxConcurrent": "Số ticket đồng thời tối đa",
    "maxConcurrentHint": "Bỏ trống nếu không giới hạn.",
    "maxConcurrentPlaceholder": "Không giới hạn",
    "channels": "Kênh",
    "channelsHint": "Các nguồn ticket mà agent này xử lý.",
    "channelsEmpty": "Chưa có kênh nào được cấu hình.",
    "notifyChannels": "Kênh thông báo",
    "notifyInApp": "Trong ứng dụng",
    "notifyInAppHint": "Luôn bật",
    "notifyTargetPlaceholder": "Chat ID hoặc webhook đích",
    "notify": {
      "telegram": "Telegram",
      "lark": "Lark"
    },
    "save": "Lưu",
    "saving": "Đang lưu…",
    "cancel": "Huỷ",
    "saved": "Đã lưu cấu hình.",
    "saveFailed": "Không thể lưu cấu hình agent."
  },
  "addAgent": {
    "title": "Thêm agent hỗ trợ",
    "subtitle": "Chọn một nhân viên nội bộ để thêm vào danh sách agent hỗ trợ.",
    "pickerLabel": "Nhân viên",
    "searchPlaceholder": "Tìm theo tên hoặc email…",
    "loading": "Đang tải danh sách nhân viên…",
    "noStaff": "Không có nhân viên nội bộ nào.",
    "noMatch": "Không tìm thấy nhân viên khớp \"{{query}}\".",
    "loadError": "Không thể tải danh sách nhân viên.",
    "submit": "Thêm agent",
    "submitting": "Đang thêm…",
    "cancel": "Huỷ",
    "added": "Đã thêm agent.",
    "addFailed": "Không thể thêm agent."
  },
  "removeAgent": {
    "title": "Xoá agent — {{name}}",
    "body": "Agent sẽ bị vô hiệu hoá và xoá khỏi danh sách agent hỗ trợ. Vai trò tài khoản không thay đổi.",
    "openTicketsCount": "{{count}} ticket đang mở sẽ được phân công lại cho các agent sẵn sàng khác trước khi xoá.",
    "noOpenTickets": "Agent này không có ticket đang mở — không cần phân công lại.",
    "confirm": "Xoá agent",
    "removing": "Đang xoá…",
    "cancel": "Huỷ",
    "removed": "Đã xoá agent.",
    "removedWithReassign": "Đã xoá agent. Đã phân công lại {{count}} ticket.",
    "removeFailed": "Không thể xoá agent.",
    "notFound": "Agent này không còn tồn tại. Danh sách đã được làm mới."
  },
  "realtime": {
    "newTicketTitle": "Ticket hỗ trợ mới",
    "newTicketBody": "Có ticket mới cần xử lý.",
    "tabFlash": "Ticket mới",
    "markRead": "Đánh dấu đã đọc",
    "markAllRead": "Đánh dấu đã đọc tất cả",
    "replyTitle": "Trả lời mới",
    "replyBody": "Khách hàng vừa trả lời một ticket."
  },
  "routingRules": {
    "title": "Quy tắc định tuyến",
    "subtitle": "Tự động phân công ticket theo danh mục, kênh hoặc SLA. Quy tắc áp dụng theo thứ tự.",
    "add": "Thêm quy tắc định tuyến",
    "empty": "Chưa có quy tắc định tuyến. Thêm quy tắc để tự động định tuyến ticket mới.",
    "loading": "Đang tải quy tắc định tuyến…",
    "loadError": "Không thể tải quy tắc định tuyến.",
    "edit": "Sửa",
    "delete": "Xoá",
    "createTitle": "Quy tắc định tuyến mới",
    "editTitle": "Sửa quy tắc định tuyến",
    "typeLabel": "Loại điều kiện",
    "matchLabel": "Giá trị khớp",
    "matchPlaceholder": "vd: Billing, webchat, hoặc mức SLA",
    "targetKindLabel": "Đích đến",
    "agentsLabel": "Phân công cho agent",
    "agentsHint": "Ticket khớp sẽ được định tuyến tới các agent đã chọn.",
    "agentsEmpty": "Chưa có agent hỗ trợ nào trong danh sách.",
    "escalateHint": "Ticket khớp sẽ được chuyển lên nhóm trực.",
    "orderLabel": "Thứ tự",
    "orderHint": "Số nhỏ hơn được xét trước.",
    "save": "Lưu quy tắc",
    "saving": "Đang lưu…",
    "cancel": "Huỷ",
    "created": "Đã tạo quy tắc định tuyến.",
    "updated": "Đã cập nhật quy tắc định tuyến.",
    "deleted": "Đã xoá quy tắc định tuyến.",
    "saveFailed": "Không thể lưu quy tắc định tuyến.",
    "deleteFailed": "Không thể xoá quy tắc định tuyến.",
    "matchRequired": "Nhập giá trị khớp.",
    "agentsRequired": "Chọn ít nhất một agent.",
    "targetAgentsSummary": "Phân công cho {{count}} agent",
    "targetEscalateSummary": "Chuyển lên nhóm trực",
    "typeAll": "Tất cả loại",
    "typeFilterAria": "Lọc theo loại điều kiện",
    "sortAria": "Sắp xếp quy tắc theo",
    "sortOrder": "Thứ tự",
    "sortCreated": "Ngày tạo",
    "dirAsc": "Tăng dần",
    "dirDesc": "Giảm dần",
    "deleteConfirmTitle": "Xoá quy tắc định tuyến?",
    "deleteConfirmBody": "Quy tắc này sẽ bị xoá và các ticket khớp sẽ không còn được tự động định tuyến theo nó.",
    "deleting": "Đang xoá…"
  },
  "routingType": {
    "category": "Danh mục",
    "channel": "Kênh",
    "sla": "SLA"
  },
  "routingTarget": {
    "agents": "Phân công cho agent",
    "escalate": "Chuyển lên (escalate)"
  },
  "availability": {
    "available": "Sẵn sàng",
    "unavailable": "Không sẵn sàng",
    "toggleAria": "Bật/tắt trạng thái sẵn sàng của tôi",
    "tooltip": "Bật/tắt việc nhận phân công ticket mới",
    "nowAvailable": "Bạn đã sẵn sàng nhận ticket mới.",
    "nowUnavailable": "Bạn đã chuyển sang không sẵn sàng — ticket mới sẽ bỏ qua bạn.",
    "toggleFailed": "Không thể cập nhật trạng thái sẵn sàng."
  },
  "channelType": {
    "webchat": "Chat trực tuyến",
    "email": "Email",
    "ai_bot": "AI Bot",
    "staff": "Nhân viên",
    "facebook": "Facebook",
    "zalo": "Zalo",
    "telegram": "Telegram",
    "wechat": "WeChat",
    "facebook_personal": "Facebook (Cá nhân)",
    "zalo_personal": "Zalo (Cá nhân)",
    "lark": "Lark"
  },
  "channelStatus": {
    "connected": "Đã kết nối",
    "disconnected": "Đã ngắt kết nối",
    "error": "Lỗi",
    "pending": "Đang chờ"
  },
  "addChannel": {
    "title": "Thêm kênh",
    "subtitle": "Kết nối nền tảng mạng xã hội để nhận tin nhắn hỗ trợ.",
    "selectPlatform": "Chọn nền tảng",
    "platformLabel": "Nền tảng",
    "nameLabel": "Tên hiển thị",
    "namePlaceholder": "VD: Trang hỗ trợ Printway",
    "next": "Tiếp theo",
    "back": "Quay lại",
    "cancel": "Hủy",
    "connect": "Kết nối",
    "connecting": "Đang kết nối…",
    "verify": "Kiểm tra kết nối",
    "verifying": "Đang kiểm tra…",
    "verified": "Đã xác minh kết nối.",
    "verifyFailed": "Không thể xác minh kết nối. Hãy kiểm tra thông tin đăng nhập và thử lại.",
    "wechatComingSoon": "Tích hợp WeChat sắp ra mắt và chưa thể kết nối.",
    "created": "Đã kết nối kênh.",
    "createFailed": "Không thể kết nối kênh.",
    "steps": {
      "facebook": "Cấp quyền cho ứng dụng Printway truy cập Trang Facebook của bạn, sau đó dán Page access token vào bên dưới.",
      "zalo": "Cấp quyền cho ứng dụng Official Account của Printway, sau đó nhập OA id và thông tin ứng dụng Zalo.",
      "telegram": "Tạo bot bằng @BotFather rồi dán bot token vào bên dưới.",
      "lark": "Tạo internal app trong Lark Developer Console, bật bot, rồi dán App ID, App Secret và verification token của Event Subscription. Sau khi kết nối, đặt URL event subscription là <api>/api/v1/support/webhooks/lark và subscribe sự kiện im.message.receive_v1."
    },
    "fields": {
      "pageId": "Page ID",
      "pageToken": "Page access token",
      "oaId": "Official Account ID",
      "appId": "App ID",
      "appSecret": "App secret",
      "botToken": "Bot token",
      "botUsername": "Tên bot",
      "accessToken": "Access token",
      "refreshToken": "Refresh token",
      "verificationToken": "Verification token"
    }
  },
  "reply": {
    "windowClosed": "Cửa sổ trả lời đã đóng",
    "windowClosedHint": "Cửa sổ nhắn tin 24 giờ đã hết hạn. Khách hàng phải nhắn lại trước khi bạn có thể trả lời.",
    "resend": "Gửi lại",
    "resending": "Đang gửi lại…",
    "resent": "Đã gửi lại tin nhắn.",
    "resendFailed": "Không thể gửi lại tin nhắn."
  },
  "deliveryStatus": {
    "queued": "Trong hàng đợi",
    "sending": "Đang gửi",
    "sent": "Đã gửi",
    "delivered": "Đã nhận",
    "read": "Đã đọc",
    "failed": "Thất bại",
    "undelivered": "Chưa gửi được",
    "pending": "Đang chờ",
    "blocked_window": "Cửa sổ đã đóng"
  },
  "linkRequester": {
    "title": "Liên kết người yêu cầu với merchant",
    "subtitle": "Ghép liên hệ mạng xã hội này với một tài khoản merchant.",
    "searchPlaceholder": "Tìm theo tên hoặc email…",
    "loading": "Đang tìm…",
    "noMatch": "Không tìm thấy merchant khớp với \"{{query}}\".",
    "link": "Liên kết",
    "linking": "Đang liên kết…",
    "linked": "Đã liên kết người yêu cầu.",
    "linkFailed": "Không thể liên kết người yêu cầu.",
    "unlink": "Hủy liên kết",
    "unlinked": "Đã hủy liên kết người yêu cầu.",
    "currentlyLinked": "Đã liên kết với {{name}}",
    "searchHint": "Nhập ít nhất 2 ký tự để tìm user và merchant.",
    "currentRequester": "Người yêu cầu hiện tại",
    "externalUnknown": "Người gửi ẩn danh",
    "platformUser": "ID nền tảng: {{id}}",
    "accountType": {
      "user": "Người dùng",
      "merchant": "Merchant"
    },
    "confirmTitle": "Xác nhận liên kết",
    "confirmPrompt": "Liên kết người gửi {{external}} trên {{platform}} với {{account}}?",
    "replaceWarning": "Thao tác này sẽ thay thế tài khoản đang liên kết ({{name}}).",
    "confirm": "Xác nhận liên kết",
    "cancel": "Hủy",
    "back": "Quay lại",
    "retry": "Thử lại",
    "searchError": "Không thể tìm tài khoản. Vui lòng thử lại."
  },
  "channelActions": {
    "empty": "Chưa có kênh nào được kết nối. Thêm một kênh để bắt đầu nhận tin nhắn.",
    "loadFailed": "Không thể tải danh sách kênh.",
    "reconnect": "Kết nối lại",
    "disconnect": "Ngắt kết nối",
    "disconnected": "Đã ngắt kết nối kênh.",
    "disconnectFailed": "Không thể ngắt kết nối kênh.",
    "deleteConfirm": "Xóa kênh này? Các cuộc trò chuyện hiện có vẫn được giữ nhưng sẽ không có tin nhắn mới.",
    "deleted": "Đã xóa kênh.",
    "deleteFailed": "Không thể xóa kênh.",
    "verifyConnection": "Kiểm tra kết nối"
  },
  "socialThread": {
    "loadOlder": "Tải tin nhắn cũ hơn",
    "loadingOlder": "Đang tải…",
    "empty": "Chưa có tin nhắn nào trong cuộc trò chuyện này.",
    "loadError": "Không thể tải cuộc trò chuyện.",
    "linkRequester": "Liên kết người yêu cầu",
    "attachmentDownload": "Tải tệp đính kèm",
    "composerPlaceholder": "Nhập câu trả lời…",
    "composerSend": "Gửi",
    "composerSending": "Đang gửi…",
    "composerAttach": "Đính kèm tệp",
    "composerAttachRemove": "Gỡ tệp đính kèm",
    "composerNotSupported": "Kênh này chưa hỗ trợ trả lời.",
    "composerSent": "Đã gửi câu trả lời.",
    "composerSendFailed": "Không thể gửi câu trả lời.",
    "deliveryErrorCode": "Mã lỗi: {{code}}",
    "deviceOffline": "Thiết bị bridge đang ngoại tuyến — tin nhắn sẽ chờ cho đến khi kết nối lại.",
    "deviceRevoked": "Thiết bị bridge này đã bị thu hồi — ghép thiết bị mới để tiếp tục."
  },
  "dispatch": {
    "title": "Đẩy cho vendor / bộ phận",
    "target": {
      "vendor": "Vendor",
      "department": "Bộ phận nội bộ"
    },
    "department": {
      "Finance": "Tài chính",
      "IT": "Kỹ thuật",
      "Logistics": "Vận hành/Giao vận",
      "Product": "Sản phẩm/Thiết kế"
    },
    "status": {
      "Dispatched": "Đã đẩy",
      "InProgress": "Đang xử lý",
      "Returned": "Đã trả về",
      "Cancelled": "Đã thu hồi"
    },
    "pickVendor": "Chọn vendor",
    "scopeNotePlaceholder": "Mô tả việc cho bên xử lý (không kèm PII merchant khi đẩy vendor)",
    "replyPlaceholder": "Trả lời trong luồng dispatch…",
    "submit": "Đẩy việc",
    "cancel": "Huỷ",
    "send": "Gửi",
    "return": "Trả về support",
    "recall": "Thu hồi",
    "empty": "Chưa có dispatch",
    "navTitle": "Hàng đợi dispatch",
    "toast": {
      "created": "Đã tạo dispatch",
      "error": "Thao tác thất bại"
    },
    "titleVendor": "Đẩy ticket cho Vendor",
    "titleDepartment": "Đẩy ticket cho Bộ phận",
    "scopeNoteLabel": "Ghi chú giao việc"
  },
  "compose": {
    "keyboardHint": "Enter để gửi · Option+Enter để xuống dòng · Dán ảnh bằng Ctrl+V",
    "attach": "Đính kèm tệp",
    "uploading": "Đang tải lên…",
    "removeAttachment": "Xoá {{filename}}",
    "linkOrder": "Gắn đơn hàng",
    "searchOrder": "Tìm đơn hàng…",
    "noOrders": "Không tìm thấy đơn hàng",
    "uploadFailTitle": "Không thể tải tệp lên",
    "fileTooLarge": "Tệp vượt quá giới hạn 10MB",
    "fileTypeForbidden": "Định dạng tệp không được phép",
    "download": "Tải xuống",
    "imageAlt": "Ảnh đính kèm",
    "attachDisabledHint": "Chỉ đính kèm được khi dispatch đang hoạt động"
  },
  "stats": {
    "all": "Tất cả ticket",
    "open": "Đang mở",
    "inProgress": "Đang xử lý",
    "awaitingHandler": "Chờ bên xử lý",
    "pendingSupportReview": "Chờ Support duyệt",
    "resolved": "Đã xử lý"
  },
  "quick": {
    "heading": "Thao tác nhanh",
    "trackOrder": {
      "label": "Theo dõi đơn hàng",
      "caption": "Kiểm tra trạng thái hoặc vị trí của đơn hàng.",
      "subject": "Theo dõi đơn hàng của tôi",
      "description": "Tôi muốn kiểm tra trạng thái và vị trí hiện tại của đơn hàng. Mã đơn hàng: "
    },
    "startReturn": {
      "label": "Yêu cầu trả hàng",
      "caption": "Gửi yêu cầu trả hàng hoặc hoàn tiền cho đơn hàng.",
      "subject": "Yêu cầu trả hàng",
      "description": "Tôi muốn yêu cầu trả hàng hoặc hoàn tiền cho đơn hàng. Mã đơn hàng: \nLý do: "
    },
    "orderIssues": {
      "label": "Sự cố đơn hàng",
      "caption": "Báo cáo vấn đề về sản phẩm hoặc giao hàng.",
      "subject": "Sự cố với đơn hàng của tôi",
      "description": "Tôi đang gặp sự cố với một sản phẩm trong đơn hàng. Mã đơn hàng: \nVấn đề gặp phải: "
    },
    "paymentHelp": {
      "label": "Hỗ trợ thanh toán",
      "caption": "Nhận hỗ trợ về hoá đơn hoặc thanh toán.",
      "subject": "Hỗ trợ thanh toán / hoá đơn",
      "description": "Tôi cần hỗ trợ về vấn đề thanh toán hoặc hoá đơn. Vui lòng mô tả câu hỏi của bạn: "
    }
  },
  "bridgeDeviceStatus": {
    "online": "Trực tuyến",
    "offline": "Ngoại tuyến",
    "revoked": "Đã thu hồi"
  },
  "bugCategoryLabels": {
    "UI": "Giao diện",
    "Logic": "Nghiệp vụ",
    "Performance": "Hiệu năng",
    "Data": "Dữ liệu",
    "Security": "Bảo mật"
  }
}
